import { Moment } from "moment"
import { createEventBus, slot } from "ts-event-bus"

const EventBus = {
    taskUpdated: slot<Moment>()
}

export default createEventBus({
    events: EventBus
})